/*  ========================================================================
    # Scripts - Overflow swipe icon
    ========================================================================  */

/**
 * Script that handles the display of the animated swipe icon.
 */

const OverflowSwipeIcon = {
  cfg: {
    swiper: document.querySelectorAll('[data-swiper-icon]'),
    containers: document.querySelectorAll('[data-swiper-trigger]')
  },

  /**
   * Show or hide icon based on viewport and container width
   *
   * @param {int} viewportWidth
   * @param {int} containerWidth
   * @param {node} icon
   */
  handleSwiperShow(viewportWidth, containerWidth, icon) {
    if (viewportWidth <= containerWidth) {
      icon.style.display = 'block';
    } else {
      icon.style.display = 'none';
    }
  },

  /**
   * Map container eventlistener and handle swipe show
   */
  containers() {
    this.cfg.containers.forEach(container => {
      const id = container.dataset.swiperTrigger;
      const icon = Array.from(this.cfg.swiper).find(swipe => swipe.dataset.swiperIcon === id);

      // Initial trigger of icon show
      this.handleSwiperShow(window.innerWidth, container.getBoundingClientRect().width, icon);

      window.addEventListener(
        'resize',
        () => {
          this.handleSwiperShow(window.innerWidth, container.getBoundingClientRect().width, icon);
        },
        { passive: true }
      );
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.containers !== undefined && this.cfg.containers !== null) {
      this.containers();
    }
  }
};

export default OverflowSwipeIcon;
